/**
 * Global FAQ Data
 * From SchemaMarkup.tsx lines 798-844
 * For homepage and general site-wide FAQs
 */

import type { FAQItem } from '../types';

export const GLOBAL_FAQS: FAQItem[] = [
  {
    question: 'What is the best time to go heli-skiing in Chile?',
    answer: 'The best time for heli-skiing in Chile is from July to September, when the Andes receive consistent snowfall and conditions are optimal. June and October can also offer excellent skiing depending on the season.',
  },
  {
    question: 'Do I need prior skiing experience for heli-skiing?',
    answer: 'Yes, heli-skiing requires advanced skiing ability. You should be comfortable skiing black diamond runs in varied snow conditions. Our IFMGA-certified guides assess each guest\'s ability and tailor the terrain accordingly.',
  },
  {
    question: 'What is included in an Apex Experience package?',
    answer: 'Our all-inclusive packages include luxury lodge accommodation, gourmet meals with wine pairings, professional guides, all equipment, airport transfers, and the adventure activity itself (helicopter flights for heli-skiing, boats for fishing, etc.).',
  },
  {
    question: 'Where are Apex Experience lodges located?',
    answer: 'Our lodges are located throughout the Chilean Andes and Patagonia. We have ski lodges at Valle Nevado and La Parva near Santiago, and fishing lodges in Northern Patagonia on Lake Yelcho and surrounding rivers.',
  },
  {
    question: 'What is the best season for fly fishing in Patagonia?',
    answer: 'The fly fishing season in Chilean Patagonia runs from November through April. Peak season is December through March when conditions are most consistent and hatches are prolific.',
  },
  {
    question: 'How much does heli-skiing in Chile cost?',
    answer: 'Heli-skiing packages in Chile typically range from $8,000 to $15,000 per person for a week-long experience, depending on the lodge selection and number of helicopter flights. Contact us for customized pricing.',
  },
  {
    question: 'What makes Chilean Andes skiing unique?',
    answer: 'The Chilean Andes offer incredible dry powder snow, vast terrain with minimal crowds, and the ability to ski during the Northern Hemisphere summer (June-October). Combined with world-class lodges and experienced guides, it\'s a premier skiing destination.',
  },
  {
    question: 'Can I combine skiing and fishing in one trip?',
    answer: 'Yes! Our Patagonia lodges offer the unique opportunity to combine heli-skiing with fly fishing. The shoulder seasons (June and October-November) are ideal for experiencing both activities.',
  },
];
